import React, { useState } from "react";
import { formatoMoneda } from "../../configuracion/validaciones";
import { mostraAlertaWarning } from "../alerts/sweetAlert";
import { useNavigate } from "react-router-dom";
const DetalleProductoPedido = ({ item, index, listaProductos, setCarritoPedidos }) => {
    console.log(item)
    const navigate = useNavigate();
    const disponibles =
        Number(item.cantidad || 0) <= Number(item.loteInventarioSeleccionado?.existenciaDisponible || 0);
    const subtotal = (parseFloat(item.price) * item.cantidad).toFixed(2);

    const incrementarCantidad = (id, loteSeleccionado = null, loteInventarioSeleccionado = null) => {
        setCarritoPedidos((prev) =>
            prev.map((producto) => {
                if (
                    producto.id === id &&
                    producto.loteSeleccionado?.id === loteSeleccionado?.id &&
                    producto.loteInventarioSeleccionado?.id === loteInventarioSeleccionado?.id
                ) {
                    let nuevaCantidad = Number(producto.cantidad || 0) + 1;

                    if (nuevaCantidad > loteInventarioSeleccionado.existencia) {
                        mostraAlertaWarning("No se permite exceder la cantidad de existencia en el inventario");
                        nuevaCantidad = loteInventarioSeleccionado.existencia;
                    }

                    const detallesPrecio = recalcularPrecio(id, nuevaCantidad, loteSeleccionado);

                    return {
                        ...producto,
                        cantidad: nuevaCantidad,
                        ...detallesPrecio,
                    };
                }

                return producto;
            })
        );
    };
    const decrementarCantidad = (id, loteSeleccionado = null, loteInventarioSeleccionado = null) => {
        setCarritoPedidos((prev) =>
            prev.map((producto) => {
                if (
                    producto.id === id &&
                    producto.loteSeleccionado?.id === loteSeleccionado?.id &&
                    producto.loteInventarioSeleccionado?.id === loteInventarioSeleccionado?.id &&
                    producto.cantidad > 1
                ) {
                    let nuevaCantidad = Number(producto.cantidad || 1) - 1;

                    if (nuevaCantidad < 1) {
                        nuevaCantidad = 1;
                    }

                    const detallesPrecio = recalcularPrecio(id, nuevaCantidad, loteSeleccionado);

                    return {
                        ...producto,
                        cantidad: nuevaCantidad,
                        ...detallesPrecio,
                    };
                }

                return producto;
            })
        );
    };

    const actualizarCantidad = (id, valor, loteSeleccionado = null, loteInventarioSeleccionado = null) => {
        setCarritoPedidos((prev) =>
            prev.map((producto) => {
                if (
                    producto.id === id &&
                    producto.loteSeleccionado?.id === loteSeleccionado?.id &&
                    producto.loteInventarioSeleccionado?.id === loteInventarioSeleccionado?.id
                ) {
                    let nuevaCantidad = parseInt(valor, 10) || 1;

                    if (nuevaCantidad < 1) {
                        nuevaCantidad = 1;
                    }

                    if (nuevaCantidad > loteInventarioSeleccionado.existencia) {
                        mostraAlertaWarning("No se permite exceder la cantidad de existencia en el inventario");
                        nuevaCantidad = loteInventarioSeleccionado.existencia;
                    }

                    const detallesPrecio = recalcularPrecio(id, nuevaCantidad, loteSeleccionado);

                    return {
                        ...producto,
                        cantidad: nuevaCantidad,
                        ...detallesPrecio,
                    };
                }

                return producto;
            })
        );
    };

    const calcularPrecioFinalConTodo = (datosProducto, cantidad, selectedLote = null) => {
        let precioFinal;
        let esMayoreoAplicado = false;

        if (selectedLote && selectedLote.precio) {
            precioFinal = parseFloat(selectedLote.precio);
        } else {
            precioFinal = parseFloat(datosProducto.precio) || 0;
        }

        let precioOriginalProducto = precioFinal;

        if (selectedLote && selectedLote.loteprecios && selectedLote.loteprecios.length > 0) {
            const nivelesMayoreoOrdenadosLote = [...selectedLote.loteprecios].sort((a, b) => b.cantidad - a.cantidad);
            for (const nivel of nivelesMayoreoOrdenadosLote) {
                if (cantidad >= nivel.cantidad) {
                    precioFinal = parseFloat(nivel.precio) || 0;
                    esMayoreoAplicado = true;
                    break;
                }
            }
        }
        else if (!selectedLote && datosProducto.productoprecios && datosProducto.productoprecios.length > 0) {
            const nivelesMayoreoOrdenados = [...datosProducto.productoprecios].sort((a, b) => b.cantidad - a.cantidad);
            for (const nivel of nivelesMayoreoOrdenados) {
                if (cantidad >= nivel.cantidad) {
                    precioFinal = parseFloat(nivel.precio) || 0;
                    esMayoreoAplicado = true;
                    break;
                }
            }
        }

        return {
            price: precioFinal.toFixed(2),
            precioOriginalProducto: precioOriginalProducto.toFixed(2),
            esMayoreoAplicado,
        };
    };

    const recalcularPrecio = (id, nuevaCantidad, loteSeleccionado) => {
        const productoCompleto = listaProductos.find(p => p.id === id);
        if (!productoCompleto) return {};
        return calcularPrecioFinalConTodo(productoCompleto, nuevaCantidad, loteSeleccionado);
    };

    const detalleProductoClick = () => {
        navigate(`/app/admin/pedidos/detalleproductopedidos`, {
            state: {
                producto: item
            }
        });
    };


    return (
        <div className="card shadow-sm p-3 border-secondary">
            <div className="d-flex justify-content-center">
                <h5 className="mb-1">{item.nombre}</h5>
            </div>
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                <div className="d-flex w-100 w-md-75 align-items-center gap-3">
                    <img
                        src={item.imagen || "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen"}
                        alt={item.nombre}
                        className="img-thumbnail rounded"
                        style={{ width: "80px", height: "80px", objectFit: "cover" }}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen";
                        }}
                    />
                    <div className="flex-grow-1 mx-2">
                        {item.loteSeleccionado && (
                            <div className="text-muted small">Lote: {item.loteSeleccionado.nombre_lote}</div>
                        )}
                        {item.loteInventarioSeleccionado && (
                            <div >
                                <div className="text-muted small">
                                    Inventario: {item.loteInventarioSeleccionado.inventarioTipo?.nombre}
                                </div>
                                <div className="text-muted small">
                                    En pedidos: {item.loteInventarioSeleccionado.enPedido} unidades
                                </div>
                                <div className={disponibles ? "text-muted small " : "text-danger small "}>
                                    Disponibles: {item.loteInventarioSeleccionado.existenciaDisponible} unidades
                                </div>
                            </div>

                        )}
                        <div className="text-muted small">
                            {item.esMayoreoAplicado ? (
                                <>
                                    <span className="text-info fw-bold">
                                        {formatoMoneda(item.price)} x {item.cantidad} unidades
                                    </span>
                                    <br />
                                    <p className="badge bg-info fs-5 text-white rounded-pill mb-1">
                                        Precio por cantidad aplicado
                                    </p>
                                </>
                            ) : (
                                <>{formatoMoneda(item.price)} x {item.cantidad} unidades</>
                            )}
                        </div>

                    </div>
                </div>

                <div className="d-flex w-100 w-md-auto align-items-center justify-content-end gap-2 mt-2 mt-md-0">
                    {item.loteSeleccionado?.loteprecios?.length > 0 && (
                        <div className="text-end">
                            <p className="badge fs-5 text-muted mb-1">
                                Precio por unidades
                            </p>
                            <ul className="list-unstyled small">
                                {
                                    [...item.loteSeleccionado.loteprecios]
                                        .sort((a, b) => a.cantidad - b.cantidad)

                                        .map((tier, idx) => (
                                            <li key={idx}>
                                                <span className={item.price === tier.precio
                                                    ? "badge bg-info mt-1"
                                                    : "text-decoration-line-through text-muted"}>
                                                    {tier.cantidad}+ = {formatoMoneda(tier.precio)}
                                                </span>
                                            </li>
                                        ))}
                            </ul>
                        </div>
                    )}

                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => decrementarCantidad(item.id, item.loteSeleccionado, item.loteInventarioSeleccionado)}
                        >
                            <i className="fas fa-minus"></i>
                        </button>
                        <input
                            type="number"
                            className="form-control form-control-sm text-center"
                            value={item.cantidad}
                            onChange={(e) => actualizarCantidad(item.id, e.target.value, item.loteSeleccionado, item.loteInventarioSeleccionado)}
                            style={{ width: "70px", minWidth: "60px", padding: "0.25rem 0.5rem" }}
                            onWheel={(e) => e.target.blur()}
                        />
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => incrementarCantidad(item.id, item.loteSeleccionado, item.loteInventarioSeleccionado)}
                        >
                            <i className="fas fa-plus"></i>
                        </button>
                    </div>

                    <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => setCarritoPedidos((prev) =>
                            prev.filter((p) => !(p.id === item.id &&
                                p.loteSeleccionado?.id === item.loteSeleccionado?.id &&
                                p.loteInventarioSeleccionado?.id === item.loteInventarioSeleccionado?.id)))}
                    >
                        <i className="fas fa-trash"></i>
                    </button>
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <h5 className="text-info text-nowrap mt-1">
                    Subtotal: {formatoMoneda(subtotal)}
                </h5>
            </div>
        </div>
    );
}
export default DetalleProductoPedido;    